import { catchError, map } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { APP_CONFIG, IAppConfig } from '../../../app.config';
import { MessageService } from '../../../core/service/message.service';
import { ProgressBarService } from '../../../core/service/progress-bar.service';
import { DataService } from '../../../core/service/base/data.service';
import { DirectDebitLog } from '../../model/direct-debit-log';
import { LocalDate } from '../../../core/model/local-date';
import { PagedFilter } from '../../../core/model/paged-filter';
import { FilterModelBase } from '../../../core/model/filter-model-base';

export class DirectDebitLogFilter extends FilterModelBase {
  showFrom: LocalDate;
  companyId: string;
  contactId: string;
  showPayments: boolean;
  invoiceNumber: string;
  payerNumber: string;
}

@Injectable()
export class DirectDebitLogService extends DataService<DirectDebitLog> {
  private readonly _defaultFilterFields: string[] = ['showFrom', 'showPayments', 'companyId', 'contactId', 'payerNumber', 'invoiceNumber'];

  constructor(client: HttpClient, notification: MessageService, progressBar: ProgressBarService, @Inject(APP_CONFIG) config: IAppConfig) {
    super(client, config, notification, DirectDebitLog, progressBar, 'direct-debit-log');
  }

  getFilterDefinition(): Observable<PagedFilter<DirectDebitLogFilter>> {
    return this.client.get<PagedFilter<DirectDebitLogFilter>>(`${this.endpoint}/filter`).pipe(
      map(res => {
        res.filter.showFrom = LocalDate.fromDate(res.filter.showFrom);
        res.filter.defaultFields = this._defaultFilterFields;
        res.filter.selectedFields = Array.isArray(res.filter.selectedFields) ? res.filter.selectedFields : this._defaultFilterFields;
        return res;
      }),
      catchError(error => {
        console.log(error);
        return [];
      })
    );
  }
}
